import { DateTimeUtils } from '@servicetitan/datetime-utils';

export const getDateText = (dateTimeUtils: DateTimeUtils, date?: Date) => {
    const validatedDate = validateDate(date);
    if (!validatedDate) {
        return 'Date unavailable';
    }
    return `${dateTimeUtils.formatShortMonth(validatedDate)} ${validatedDate.getDate()}, ${validatedDate.getFullYear()}`;
};

export const validateDate = (dateToValidate?: Date) => {
    if (dateToValidate && dateToValidate.getFullYear() < 1900) {
        return undefined;
    }
    return dateToValidate;
};
